"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabsManager = void 0;
const LabsMapper_1 = require("../../mappers/LabsMapper");
const uuid_1 = require("uuid");
class LabsManager {
    constructor(httpAdapter) {
        this.changeListeners = [];
        this.removeListeners = [];
        this.httpAdapter = httpAdapter;
        this._labRequisitions = [];
        this._labsData = [];
        this._labDetails = undefined;
    }
    get labRequisitions() {
        return this._labRequisitions;
    }
    get labsData() {
        return this._labsData;
    }
    get labDetails() {
        return this._labDetails;
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this._labRequisitions));
    }
    destory() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    getLabs(context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.getLabsAdapter().getLabs(context);
            if (!response.isAborted) {
                this._labsData = (0, LabsMapper_1.labsMapper)(response.data);
            }
        });
    }
    getLabDetails(labId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getLabsAdapter()
                .getLabDetails(labId, context);
            if (!response.isAborted) {
                this._labDetails = (0, LabsMapper_1.labDetailsMapper)(response.data);
            }
        });
    }
    requestLab(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpAdapter.getLabsAdapter().requestLab(data);
        });
    }
    getLabRequisitions(groupId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getLabsAdapter()
                .getLabRequisitions(groupId, context);
            if (!response.isAborted) {
                this._labRequisitions = response.data.data;
                this.notifyChange();
            }
        });
    }
    getLabRequisitionOrders(requisitionId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getLabsAdapter()
                .getLabRequisitionOrders(requisitionId, context);
            if (!response.isAborted) {
                this._labRequisitions = this._labRequisitions.map(r => {
                    if (r.id === requisitionId) {
                        return Object.assign(Object.assign({}, r), { orders: response.data.data });
                    }
                    else {
                        return r;
                    }
                });
                this.notifyChange();
            }
        });
    }
}
exports.LabsManager = LabsManager;
